var path = '/shared/javascripts/templates/svelte_page_with_view.html';
var html = "<angular-to-svelte svelte-component=\"svelteComponentConstructor\" props=\"svelteProps\">\n</angular-to-svelte>\n\n<div ui-view></div>\n";
window.angular.module('tiz').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;